/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component, { type ComponentAttrs } from 'flarum/common/Component';
import icon from 'flarum/common/helpers/icon';
import type Mithril from 'mithril';
import BookshelfArticleCount from './BookshelfArticleCount';
import BookshelfPrivacyLabel from './BookshelfPrivacyLabel';
import type Bookshelf from '../../common/models/Bookshelf';

export interface BookshelfRadioAttrs extends ComponentAttrs {
	bookshelf?: Bookshelf;
	isSelected: boolean;
	setBookshelf: (event: MouseEvent) => void;
}

export default class BookshelfRadio<CustomAttrs extends BookshelfRadioAttrs = BookshelfRadioAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelf, isSelected, setBookshelf } = this.attrs;

		return (
			<div className={`BookshelfRadio ${isSelected ? 'isSelected' : ''} ${bookshelf ? '' : 'isNone'}`} onclick={setBookshelf}>
				<div className="BookshelfRadio-select">{isSelected ? icon('fa-sharp fa-regular fa-dot-circle') : icon('fa-sharp fa-regular fa-circle')}</div>
				<div className="BookshelfRadio-info">
					{bookshelf ? (
						[
							<div className="BookshelfRadio-bookshelf_title">{bookshelf.name()}</div>,
							<BookshelfArticleCount bookshelf={bookshelf} />,
							<BookshelfPrivacyLabel bookshelf={bookshelf} />,
						]
					) : (
						<div className="BookshelfRadio-bookshelf_title">{app.translator.trans('glowingblue-orell-bookshelf.forum.article_dropdown.none')}</div>
					)}
				</div>
				<div className="BookshelfRadio-icon">{icon(bookshelf ? 'fa-sharp fa-light fa-books' : 'fa-sharp fa-light fa-ban')}</div>
			</div>
		);
	}
}
